import React, { Component } from "react";
import swal from 'sweetalert';
import { Table } from "react-bootstrap";


import { bin } from "react-icons-kit/icomoon/bin";
import { incidentsOption } from "../../../libs/services";

import LabelForm from "../../../components/LabelForm";
import SelectForm from "../../../components/SelectForm";
import PlusButton from "../../../components/PlusButton";
import IconButton from "../../../components/IconButton";
import InputForm from "../../../components/InputForm";

class Incidents extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.addIncident = this.addIncident.bind(this);
        this.removeIncident = this.removeIncident.bind(this);
        this.getIncidents = this.getIncidents.bind(this);
        this.setIncidents = this.setIncidents.bind(this);

        this.state = {
            incidentCat:'EXTRACTION',
            incidentsType:[],
            incidentType:'',
            incidents:[],
        };
    }

    async componentDidMount(){
        this.props.onRef(this);
        
        var options = [];
        var response = await incidentsOption(this.state.incidentCat);
        if(response){
            options = [];
            response.forEach((res)=>{
                options.push({
                    value:res.id,
                    text:res.name
                });
            });

            this.setState({incidentsType:options});
        }

    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    handleChange(e){
        this.setState({[e.target.name]:e.target.value});
    }

    addIncident(){
        var incidents = this.state.incidents;
        var error = '';
        if(this.state.incidentType === ''){
            error = 'Debe seleccionar un incidente';
            swal('Error', error, 'error');
        }
        
        if(error === ''){
            var index = incidents.findIndex(obj => obj.id === parseInt(this.state.incidentType));
            
            if(index === -1){
                this.setIncidents(this.state.incidentType);                
            }else{
                swal('Error', 'El incidente ya se encuentra en la lista', 'error');
            }
        }
        
    }

    removeIncident(e, i){
        var incidents = this.state.incidents;
        incidents.splice(i, 1);
        this.setState({incidents: incidents});
    }

    getIncidents(){
        var incidents = [];
        this.state.incidents.forEach((incident)=>{
            incidents.push(incident.id);
        });

        return incidents;
    }

    setIncidents(value){
        var incidents = this.state.incidents;
        var index = this.state.incidentsType.findIndex(item => item.value === parseInt(value));
            
        if(index !== -1){            
            var incident = {
                category:'EXTRACCIÖN',
                id:this.state.incidentsType[index].value,
                name:this.state.incidentsType[index].text
            };
            incidents.push(incident);

            this.setState({
                incidents: incidents,
                incidentType:''
            });
        }
    }

    render(){
        const {t} = this.props;


        return(
            <fieldset>
                <legend style={{width:"80%"}}>Incidentes</legend>            
                <div className="col-xs-12 col-sm-6 no-padding">
                    <div className="col-xs-12 col-sm-6">
                        <LabelForm text={t('content.extractions.st.incident')} />
                        <InputForm
                            id="incident"
                            value={this.state.incidentCat === 'EXTRACTION' ? 'EXTRACCIÓN' : ''}                        
                            handleChange={this.handleChange}
                            disabled
                        />
                    </div>							
                    <div className="col-xs-12 col-sm-5 form-group">
                        <LabelForm text={t('content.extractions.st.select')} />
                        <SelectForm 
                            id="incidentType"
                            value={this.state.incidentType}
                            options={this.state.incidentsType}
                            handleChange={this.handleChange}
                            disabled={this.props.disabled}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-1" style={{marginTop:"18px"}}>
                        <PlusButton 
                            disabled={this.props.disabled}
                            action={this.addIncident}
                        />
                    </div>
                    <div className="col-xs-12 no-padding">
                        <div className="col-xs-12 col-sm-11">
                            <Table responsive hover>
                                <thead>
                                    <tr>
                                        <th>{t('content.extractions.incidents.category')}</th>
                                        <th>{t('content.extractions.incidents.type')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.incidents.map((v, i) => (
                                        <tr key={i}>
                                            <td>{v.category}</td>
                                            <td>{v.name}</td>
                                            <td>
                                                {this.props.disabled &&
                                                    <IconButton 
                                                        class="btn-info btn-xs"
                                                        title="Eliminar"
                                                        styles={{marginRight:3}}
                                                        icon={bin}
                                                        action={this.removeIncident}
                                                        variables={i}
                                                    />
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </Table>
                        </div>

                    </div>
                        
                </div>
            </fieldset>
        )
    }
}

export default Incidents;